import * as React from 'react';

import { createIcon } from '../Icon';
export const ChevronsRightIcon = createIcon(
  <React.Fragment>
    <polyline points="13 17 18 12 13 7" />
    <polyline points="6 17 11 12 6 7" />
  </React.Fragment>,
  'ChevronsRightIcon'
);
